/*
uploadedImageUrls.js
Mirrors parseUploadedImageUrls in the mobile app (app/recipe/[id].tsx) --
change one, change the other.
*/

// uploaded_image_urls arrives as a JSON-encoded list. Tolerate every shape the
// backend has produced over time: a list, a JSON string, absent, or malformed.
// Recipes created before multi-page capture only have the single
// uploaded_image_url, so fall back to it.
export const parseUploadedImageUrls = (recipe) => {
  const single =
    (recipe?.uploaded_image_url && String(recipe.uploaded_image_url).trim()) ||
    null;
  const raw = recipe?.uploaded_image_urls;

  let list = raw;
  if (typeof raw === "string" && raw.trim()) {
    try {
      list = JSON.parse(raw);
    } catch {
      list = null;
    }
  }

  if (Array.isArray(list)) {
    const urls = list.map((u) => String(u).trim()).filter(Boolean);
    if (urls.length > 0) return urls;
  }

  return single ? [single] : [];
};
